
import { createSlice } from '@reduxjs/toolkit';


const initialState = {
  savingGoalAmount: "100000",
  existingInvestment: "1000",
  expectedInflation: "8",
  expectedReturn: "8",
  timePeriod: "8",
  monthlyInvestment: '',
  futureValueOfGoal: null,
  futureValueOfExistingInvestment: null,
  savingErrors: null
};

// First, let's create the slice for savings calculator
const savingsSlice = createSlice({
  name: 'savingsCalculator',
  initialState: initialState,
  reducers: {
    setSavingGoalAmount: (state, action) => {
      state.savingGoalAmount = action.payload;
    },
    setExistingInvestment: (state, action) => {
      state.existingInvestment = action.payload;
    },
    setExpectedInflation: (state, action) => {
      state.expectedInflation = action.payload;
    },
    setExpectedReturn: (state, action) => {
      state.expectedReturn = action.payload;
    },
    setTimePeriod: (state, action) => {
      state.timePeriod = action.payload;
    },
    setMonthlyInvestment: (state, action) => {
      state.monthlyInvestment = action.payload;
    },
    setFutureValueOfGoal: (state, action) => {
      state.futureValueOfGoal = action.payload;
    },
    setFutureValueOfExistingInvestment: (state, action) => {
      state.futureValueOfExistingInvestment = action.payload;
    },
    setSavingErrors: (state, action) => {
      state.savingErrors = action.payload;
    },
    resetSavingData: (state) => {
      return initialState;
    },
  }
});

export const {
  setSavingGoalAmount,
  setExistingInvestment,
  setExpectedInflation,
  setTimePeriod,
  setMonthlyInvestment,
  setFutureValueOfGoal,
  setFutureValueOfExistingInvestment,
  setExpectedReturn, 
  resetSavingData,
   setSavingErrors
} = savingsSlice.actions;

export default savingsSlice.reducer;
export const { setActiveCalculater } = savingsSlice.actions;
